import React, { Component, createRef } from 'react';
import Parser from 'html-react-parser';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import { ChevronLeftIcon, ChevronRightIcon, ArrowIcon } from './SVGIcons';

// Импорт стилей Swiper
import 'swiper/css';
import 'swiper/css/navigation';

class First extends Component {
  static defaultProps = {

  }

  state = {
    isBeginning: true,
    isEnd: false,
    mainSliderIsBeginning: true,
    mainSliderIsEnd: false,
    lightboxOpen: false,
    currentImageIndex: 0
  }

  constructor(props) {
    super(props);
    this.swiperRef = createRef();
    this.mainSwiperRef = createRef();
  }

  handleSlideChange = (swiper) => {
    this.setState({
      isBeginning: swiper.isBeginning,
      isEnd: swiper.isEnd
    });
  }

  handleMainSlideChange = (swiper) => {
    this.setState({
      mainSliderIsBeginning: swiper.isBeginning,
      mainSliderIsEnd: swiper.isEnd
    });
  }

  // Открыть lightbox с выбранным изображением
  openLightbox = (index) => {
    this.setState({
      lightboxOpen: true,
      currentImageIndex: index
    });
    // Блокируем прокрутку страницы
    document.body.style.overflow = 'hidden';
  }

  // Закрыть lightbox
  closeLightbox = () => {
    this.setState({
      lightboxOpen: false
    });
    // Возвращаем прокрутку страницы
    document.body.style.overflow = 'auto';
  }

  // Переключение на следующее изображение
  nextImage = () => {
    const { currentImageIndex } = this.state;
    const mimages = [
      'src/images/Statia.png',
      'src/images/Statia.png',
      'src/images/Statia.png'
    ];
    
    if (currentImageIndex < mimages.length - 1) {
      this.setState({
        currentImageIndex: currentImageIndex + 1
      });
    }
  }

  // Переключение на предыдущее изображение
  prevImage = () => {
    const { currentImageIndex } = this.state;
    
    if (currentImageIndex > 0) {
      this.setState({
        currentImageIndex: currentImageIndex - 1
      });
    }
  }

  // Обработка нажатия клавиш
  handleKeyDown = (e) => {
    if (!this.state.lightboxOpen) return;
    
    if (e.key === 'Escape') {
      this.closeLightbox();
    } else if (e.key === 'ArrowRight') {
      this.nextImage();
    } else if (e.key === 'ArrowLeft') {
      this.prevImage();
    }
  }

  componentDidMount() {
    // Добавляем обработчик клавиш
    window.addEventListener('keydown', this.handleKeyDown);
  }

  componentWillUnmount() {
    // Удаляем обработчик клавиш и возвращаем прокрутку
    window.removeEventListener('keydown', this.handleKeyDown);
    document.body.style.overflow = 'auto';
  }

  render() {
    const { isBeginning, isEnd, mainSliderIsBeginning, mainSliderIsEnd, lightboxOpen, currentImageIndex } = this.state
    
    const data = this.props?.data || {}

    const mimages = data?.images || []
    const items = data?.stati?.items || []

    const currentImage = mimages[currentImageIndex];

    return (
      <>
        <div className='mt-[40px]'>
          <div className='container'>
            <div className='flex flex-col lg:flex-row items-start justify-start gap-[40px]'>
              {/* Слайдер с изображениями */}
              <div className='relative flex-none w-full lg:w-[440px]'>
                <Swiper
                  onSwiper={(swiper) => {
                    this.mainSwiperRef.current = swiper;
                    this.handleMainSlideChange(swiper);
                  }}
                  onSlideChange={this.handleMainSlideChange}
                  modules={[Navigation]}
                  spaceBetween={0}
                  slidesPerView={1}
                  className='rounded-[14px] overflow-hidden'
                >
                  {mimages.map((img, index) => (
                    <SwiperSlide key={index}>
                      <div 
                        className='cursor-pointer'
                        onClick={() => this.openLightbox(index)}
                      >
                        <img 
                          src={img} 
                          width={440} 
                          height={483} 
                          alt='slide' 
                          className='w-full h-auto' 
                        />
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>
                
                {/* Кнопки навигации поверх слайдера по центру */}
                <div className='absolute top-1/2 left-[20px] -translate-y-1/2 z-10'>
                  <div 
                    className={`w-[38px] h-[38px] rounded-[14px] flex items-center justify-center bg-[#F6F7F8] text-[#141414] cursor-pointer transition-opacity duration-300 ${
                      mainSliderIsBeginning ? 'opacity-30 cursor-not-allowed' : 'opacity-100 hover:bg-[#E8E9EA]'
                    }`}
                    onClick={() => !mainSliderIsBeginning && this.mainSwiperRef.current?.slidePrev()}
                  >
                    <ChevronLeftIcon width={6} height={12} stroke="currentColor" />
                  </div>
                </div>
                <div className='absolute top-1/2 right-[20px] -translate-y-1/2 z-10'>
                  <div 
                    className={`w-[38px] h-[38px] rounded-[14px] flex items-center justify-center bg-[#F6F7F8] text-[#141414] cursor-pointer transition-opacity duration-300 ${
                      mainSliderIsEnd ? 'opacity-30 cursor-not-allowed' : 'opacity-100 hover:bg-[#E8E9EA]'
                    }`}
                    onClick={() => !mainSliderIsEnd && this.mainSwiperRef.current?.slideNext()}
                  >
                    <ChevronRightIcon width={6} height={12} stroke="currentColor" />
                  </div>
                </div>
              </div>
              
              <div className='flex-auto leading-none'>
                <div className='text-base text-ptgray'>{data?.publishedon || ''}</div>
                <div className='text-title text-ptblack uppercase tracking-tight mt-[12px]'>{Parser(data?.h1 || data?.pagetitle)}</div>
                <div className='mt-[40px] bg-[#F6F7F8] p-[20px] rounded-[14px] text-base text-ptgray page_content'>
                  {Parser(data?.content || '')}
                </div>
              </div>
            </div>
            <div className='flex items-center justify-between gap-[20px] mt-[80px] xl:mt-[100px]'>
              <div className='text-title text-ptblack uppercase tracking-tight'>Другие <span className='text-ptgray'>статьи</span></div>
              <div className='flex items-center gap-[10px]'>
                {/* Левая кнопка навигации */}
                <div 
                  className={`w-[38px] h-[38px] rounded-[14px] flex items-center justify-center bg-[#F6F7F8] text-[#141414] cursor-pointer transition-opacity duration-300 ${
                    isBeginning ? 'opacity-30 cursor-not-allowed' : 'opacity-100 hover:bg-[#E8E9EA]'
                  }`}
                  onClick={() => !isBeginning && this.swiperRef.current?.slidePrev()}
                >
                  <ChevronLeftIcon width={6} height={12} stroke="currentColor" />
                </div>
                {/* Правая кнопка навигации */}
                <div 
                  className={`w-[38px] h-[38px] rounded-[14px] flex items-center justify-center bg-[#F6F7F8] text-[#141414] cursor-pointer transition-opacity duration-300 ${
                    isEnd ? 'opacity-30 cursor-not-allowed' : 'opacity-100 hover:bg-[#E8E9EA]'
                  }`}
                  onClick={() => !isEnd && this.swiperRef.current?.slideNext()}
                >
                  <ChevronRightIcon width={6} height={12} stroke="currentColor" />
                </div>
              </div>
            </div>
            
            {/* Слайдер Swiper */}
            <div className='mt-[40px]'>
              <Swiper
                onSwiper={(swiper) => {
                  this.swiperRef.current = swiper;
                  this.handleSlideChange(swiper);
                }}
                onSlideChange={this.handleSlideChange}
                modules={[Navigation]}
                spaceBetween={21}
                slidesPerView={3}
                breakpoints={{
                  0: {
                    slidesPerView: 1,
                    spaceBetween: 16
                  },
                  640: {
                    slidesPerView: 2,
                    spaceBetween: 20
                  },
                  1024: {
                    slidesPerView: 3,
                    spaceBetween: 21
                  }
                }}
              >
                {items.map((el, index) => (
                  <SwiperSlide key={index}>
                    <div className='bg-cover bg-center rounded-[14px] overflow-hidden' style={{ backgroundImage: `url('${el.image}')` }}>
                      <div className='w-full min-h-[215px] p-[20px] bg-gradient-to-t from-[#00135133]/20 to-[#00071E] flex flex-col justify-between items-start'>
                        <div className='text-cardTitle text-white uppercase leading-none font-light max-w-[255px]'>{el.title}</div>
                        <div className='w-full flex items-end justify-between'>
                          <div className='text-base text-white/70'>{el.data}</div>
                          <a href={el.href} className='cursor-pointer bg-white duration-300 ease-in-out hover:bg-[#DBE7F3] px-[22px] h-[38px] flex-none flex items-center justify-center rounded-[14px] gap-[12px] text-ptblack'>
                            <div className='text-base'>Читать статью</div>
                            <ArrowIcon width={16} height={16} stroke="currentColor" />
                          </a>
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>

          </div>
        </div>

        {/* Lightbox для увеличения изображений */}
        {lightboxOpen && (
          <div 
            className='fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-90'
            onClick={this.closeLightbox}
          >
            {/* Кнопка закрытия */}
            <button 
              className='absolute top-5 right-5 text-white text-4xl hover:text-gray-300 z-10 w-[50px] h-[50px] flex items-center justify-center rounded-full bg-black/50 hover:bg-black/70 transition-colors'
              onClick={this.closeLightbox}
            >
              ×
            </button>

            {/* Кнопка предыдущего изображения */}
            {currentImageIndex > 0 && (
              <button 
                className='absolute left-5 top-1/2 -translate-y-1/2 text-white text-5xl hover:text-gray-300 z-10 w-[50px] h-[50px] flex items-center justify-center rounded-full bg-black/50 hover:bg-black/70 transition-colors'
                onClick={(e) => {
                  e.stopPropagation();
                  this.prevImage();
                }}
              >
                ‹
              </button>
            )}

            {/* Изображение */}
            <div 
              className='relative max-w-[90vw] max-h-[90vh] rounded-[15px] overflow-hidden'
              onClick={(e) => e.stopPropagation()}
            >
              <img 
                src={currentImage} 
                alt='Увеличенное изображение'
                className='max-w-full max-h-[90vh] object-contain'
              />
              
              {/* Счетчик изображений */}
              <div className='absolute bottom-5 left-1/2 -translate-x-1/2 text-white bg-black bg-opacity-70 px-4 py-2 rounded-full text-sm'>
                <span>{currentImageIndex + 1} / {mimages.length}</span>
              </div>
            </div>

            {/* Кнопка следующего изображения */}
            {currentImageIndex < mimages.length - 1 && (
              <button 
                className='absolute right-5 top-1/2 -translate-y-1/2 text-white text-5xl hover:text-gray-300 z-10 w-[50px] h-[50px] flex items-center justify-center rounded-full bg-black/50 hover:bg-black/70 transition-colors'
                onClick={(e) => {
                  e.stopPropagation();
                  this.nextImage();
                }}
              >
                ›
              </button>
            )}
          </div>
        )}
      </>
    )
  }
}

export default First;